import { Config } from "../Config.js";
import { ENVIRONMENT } from "../types/EnvironmentType.js";
/**
 * Determines whether the current environment is the stg environment.
 *
 * @return {boolean}
 */ export var isStgEnvironment = function() {
    return Config.env === ENVIRONMENT.stg;
};

//# sourceMappingURL=isStgEnvironment.js.map